import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import { apiMajorRecentLeaseTransactions } from '../../services/apis/retail/apiMajorRecentLeaseTransactions';

class MajorRecentLeaseTransactions extends React.Component {
    state = {
        majorRecentLeaseTransactions: []
    }

    componentDidMount() {
        apiMajorRecentLeaseTransactions.get().then((res) => {
            this.setState({ majorRecentLeaseTransactions: res.data });
        });
    }

    render() {
        return (
            <div className="col-lg-8">
                <div className="widget widgetTable">
                    <div className="row">
                        <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                            <p>Major Recent Lease Transactions</p>
                        </div>
                        <div className="col-lg-3 text-end">
                            <Link to="/#" className="colorBlack">
                                <FontAwesomeIcon icon={faEllipsisV} />
                            </Link>
                        </div>
                        <div className="col-lg-12 mt-2">
                            <Table responsive hover>
                                <thead>
                                    <tr className="tableTdColor">
                                        <th>Occupier</th>
                                        <th>Date</th>
                                        <th>Asset</th>
                                        <th>ChargeableArea (sqft) </th>
                                        <th>Rent (₹/sqft/month)</th>
                                        <th>City</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.majorRecentLeaseTransactions.map((row, i) => (
                                        <tr className="tableTdColor" key={i}>
                                            <td>{row.tenant}</td>
                                            <td>{row.execution_date}</td>
                                            <td>{row.complex}</td>
                                            <td>{row.area}</td>
                                            <td>{row.rent}</td>
                                            <td>{row.city}</td>
                                        </tr>
                                    ))}
                                    {/* <tr className="tableTdColor">
                                        <td>HCL</td>
                                        <td>Jun-2021</td>
                                        <td>Alturaz</td>
                                        <td>@123,456</td>
                                        <td>93.5</td>
                                        <td>Bengaluru</td>
                                    </tr>
                                    <tr className="tableTdColor">
                                        <td>ABC</td>
                                        <td>Jun-2021</td>
                                        <td>Aster</td>
                                        <td>23,456</td>
                                        <td>73.5</td>
                                        <td>MMR</td>
                                    </tr>
                                    <tr className="tableTdColor">
                                        <td>HCL</td>
                                        <td>Jun-2021</td>
                                        <td>Alturaz</td>
                                        <td>@123,456</td>
                                        <td>93.5</td>
                                        <td>Bengaluru</td>
                                    </tr>
                                    <tr className="tableTdColor">
                                        <td>ABC</td>
                                        <td>Jun-2021</td>
                                        <td>Aster</td>
                                        <td>23,456</td>
                                        <td>73.5</td>
                                        <td>MMR</td>
                                    </tr>
                                    <tr className="tableTdColor">
                                        <td>HCL</td>
                                        <td>Jun-2021</td>
                                        <td>Alturaz</td>
                                        <td>@123,456</td>
                                        <td>93.5</td>
                                        <td>Bengaluru</td>
                                    </tr> */}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default MajorRecentLeaseTransactions;
